import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import EntitiesTable from 'components/organisms/Tables/EntitiesTable/EntitiesTable';

const StyledDealflowEntitiesTable = styled(EntitiesTable)`
  ${ComponentStyles}
`;

StyledDealflowEntitiesTable.propTypes = {
  theme: PropTypes.object
};

export default StyledDealflowEntitiesTable;
